import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import Home from './pages/Home';
import Devices from './pages/Devices';
import Guests from './pages/Guests';
import About from './pages/About';

import ProtectedRoute from './components/ProtectedRoute';


const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
      <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/devices/:propertyId"
          element={
            <ProtectedRoute>
              <Devices />
            </ProtectedRoute>
          }/>
        <Route 
          path="/guests/:propertyId"
          element={
            <ProtectedRoute>
              <Guests />
            </ProtectedRoute>
          }/>
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
};

export default App;
